import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { LegalLinkItems } from "../legal/legalLinks";
import AuthSection from "../auth/AuthSection";
import LandingPricing from "../auth/LandingPricing";
import { fetchBlogArticles } from "../blog/blogApi";
import { formatBlogDate } from "../blog/blogUtils";
import "./SimpleLanding.css";

function SimpleLanding({ logoCyrSrc, logoError, setLogoError }) {
  const authRef = useRef(null);
  const scrollToAuth = () => authRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // Свежие статьи на главной: и перелинковка для поиска, и видно, что продукт живой
  const [latestArticles, setLatestArticles] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchBlogArticles({ perPage: 3 })
      .then((data) => {
        if (!cancelled) setLatestArticles((data?.articles || []).slice(0, 3));
      })
      .catch(() => {
        if (!cancelled) setLatestArticles([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="simple-landing-wrap">
      <section className="simple-landing">
        <div className="simple-landing__content panel">
          <a href="/" className="simple-landing__brand-link" aria-label="Энилекс.Контроль">
            <div className="simple-landing__brand">
              {!logoError ? (
                <img
                  src={logoCyrSrc}
                  alt="Энилекс"
                  className="hero__logo hero__logo--cyr"
                  onError={() => setLogoError(true)}
                />
              ) : (
                <h1 className="simple-landing__brand-fallback">Энилекс</h1>
              )}
              <span className="simple-landing__brand-dot">.Контроль</span>
            </div>
          </a>

          <Link className="simple-landing__blog-link" to="/blog">
            Блог о работе на маркетплейсах →
          </Link>

          <h2 className="simple-landing__title">Регистрация</h2>
          <ul className="simple-landing__list">
            <li>SEO, реклама, аналитика — сервис делает эту работу вместо вас, а не просто показывает цифры.</li>
            <li>Полный контроль над тем, что происходит в ваших магазинах на WB и Ozon.</li>
            <li>Часть работы, которую раньше закрывали штатные сотрудники, теперь закрывает сервис.</li>
            <li>AI-агент обучен методологией агентства Энилекс — разбирается в маркетплейсах, а не отвечает общими фразами.</li>
            <li>Несколько магазинов в одном проекте и сквозные отчёты по всем сразу.</li>
          </ul>
        </div>
        <div ref={authRef}>
          <AuthSection />
        </div>
      </section>

      <section className="simple-landing__pricing panel">
        <LandingPricing onRegisterClick={scrollToAuth} />
      </section>

      {latestArticles.length ? (
        <section className="simple-landing__blog panel">
          <div className="simple-landing__blog-head">
            <h2>Свежее в блоге</h2>
            <Link to="/blog">Все материалы →</Link>
          </div>
          <div className="simple-landing__blog-grid">
            {latestArticles.map((article) => (
              <Link
                key={article.slug}
                className="simple-landing__blog-card"
                to={`/blog/${article.slug}`}
              >
                <span className="simple-landing__blog-meta">
                  {article.category} · {formatBlogDate(article.publishedAt)}
                </span>
                <span className="simple-landing__blog-title">{article.title}</span>
                <span className="simple-landing__blog-desc">{article.description}</span>
              </Link>
            ))}
          </div>
        </section>
      ) : null}

      <footer className="simple-landing__footer">
        <Link to="/blog">Блог</Link>
        <LegalLinkItems short />
      </footer>
    </div>
  );
}

export default SimpleLanding;
